import { Flex, Spacing, TabsGroup } from '@billy/design-system'
import { ReactElement } from 'react'

import { ClientInvoicesList } from './elements/ClientInvoicesList'
import { ClientQuotesList } from './elements/ClientQuotesList'
import { DocumentTab } from './elements/DocumentTab'
import { DocumentType } from './enums/DocumentType'
import { useDocumentsTabs } from './hooks/useDocumentsTabs'
import * as Styled from './styles'

export const ClientDocuments = (): ReactElement => {
  const { activeTab, selectTab, tabs } = useDocumentsTabs()

  return (
    <Styled.ClientDocumentsWrapper>
      <Flex flexDirection="column" gap={Spacing.S24}>
        <TabsGroup>
          {tabs.map((tab) => (
            <DocumentTab key={tab.documentType} active={activeTab === tab.documentType} onClick={selectTab} tab={tab} />
          ))}
        </TabsGroup>
        <Styled.ClientListWrapper>
          {activeTab === DocumentType.INVOICE && <ClientInvoicesList />}
          {activeTab === DocumentType.QUOTE && <ClientQuotesList />}
        </Styled.ClientListWrapper>
      </Flex>
    </Styled.ClientDocumentsWrapper>
  )
}
